// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__23Dsb","copyright":"Footer_copyright__ePFqS","links":"Footer_links__kwgOr","link":"Footer_link__UvExP","dot":"Footer_dot__MXIox"};